import trackEvent from './analytics';

export const FLEX_EVENTS = {
    CARD_ELIGIBLE: 'flex_card_eligible',
    CARD_GENERATED: 'flex_card_generated',
    CARD_SHARED: 'flex_card_shared',
    CARD_DOWNLOADED: 'flex_card_downloaded',
    CARD_LINK_COPIED: 'flex_card_link_copied',
    CARD_VIEWED: 'flex_card_viewed',
    CARD_DELETED: 'flex_card_deleted',
    CARD_VISIBILITY_CHANGED: 'flex_card_visibility_changed',
    CHALLENGE_CREATED: 'flex_challenge_created',
    CHALLENGE_STARTED: 'flex_challenge_started',
    CHALLENGE_COMPLETED: 'flex_challenge_completed',
    CHALLENGE_DECLINED: 'flex_challenge_declined',
    CHALLENGE_EXPIRED: 'flex_challenge_expired',
    CHALLENGE_REMATCH: 'flex_challenge_rematch',
    CHALLENGE_FORWARDED: 'flex_challenge_forwarded',
    CHALLENGE_INVITE_SENT: 'flex_challenge_invite_sent',
    PROFILE_ENABLED: 'flex_profile_enabled',
    PROFILE_DISABLED: 'flex_profile_disabled',
    PROFILE_VIEWED: 'flex_profile_viewed',
    LEADERBOARD_VIEWED: 'flex_leaderboard_viewed',
    LEADERBOARD_OPTED_IN: 'flex_leaderboard_opted_in',
    LEADERBOARD_OPTED_OUT: 'flex_leaderboard_opted_out',
    FEED_POSTED: 'flex_feed_posted',
    FEED_REACTED: 'flex_feed_reacted',
    FEED_VIEWED: 'flex_feed_viewed',
    SHORT_LINK_CLICKED: 'flex_short_link_clicked',
    EMBED_LOADED: 'flex_embed_loaded',
    EMBED_CTA_CLICKED: 'flex_embed_cta_clicked',
};

export function trackFlexEvent(eventName, properties = {}) {
    trackEvent(eventName, properties);
}

export default FLEX_EVENTS;
